import { Reducer } from 'redux'
import {
  DocumenterActionTypes,
  DocumenterRunClearedPayload,
  DocumenterRunCompletedPayload,
  DocumenterRunFailedPayload,
  DocumenterRunProgressPayload,
  DocumenterState
} from './types'

const initialState: DocumenterState = {
  runs: {}
}

const reducer: Reducer<DocumenterState> = (state = initialState, action) => {
  switch (action.type) {
    case DocumenterActionTypes.RUN_PROGRESS: {
      const { runId, progress } = action.payload as DocumenterRunProgressPayload
      return {
        ...state,
        runs: {
          ...state.runs,
          [runId]: { status: 'in_progress', progress }
        }
      }
    }
    case DocumenterActionTypes.RUN_COMPLETED: {
      const { runId, progress } = action.payload as DocumenterRunCompletedPayload
      const prev = state.runs[runId]
      return {
        ...state,
        runs: {
          ...state.runs,
          [runId]: { status: 'completed', progress: progress ?? prev?.progress }
        }
      }
    }
    case DocumenterActionTypes.RUN_FAILED: {
      const { runId, error, progress } = action.payload as DocumenterRunFailedPayload
      const prev = state.runs[runId]
      return {
        ...state,
        runs: {
          ...state.runs,
          [runId]: { status: 'failed', progress: progress ?? prev?.progress, error }
        }
      }
    }
    case DocumenterActionTypes.RUN_CLEARED: {
      const { runId } = action.payload as DocumenterRunClearedPayload
      if (!state.runs[runId]) return state
      const { [runId]: _, ...rest } = state.runs
      return { ...state, runs: rest }
    }
    default:
      return state
  }
}

export { reducer as documenterReducer }
